<template>
  <div>
    <menu-pae :inFocus="false">
      <menu-processo :numeroProcesso="numeroProcesso" :apensado="apensado"/>
    </menu-pae>

    <div class="d-flex justify-content-center">
      <div class="row container-md">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/elaboracao/consulta">Elaboração</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">Anexar</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-7 col-sm-12 text-md-right text-sm-center" style="padding: 0.75rem 1rem;">
          <div id="numeroProcesso" class="form-row">
            <div id="protocolo" class="col">
              <span>
                <h5>
                  <span class="badge badge-primary">Protocolo: <router-link class="text-white" :to="`/virtus/visualizadorProcesso?numeroProcesso=${numeroProcesso}`">{{ formatarProtocolo(numeroProcesso).value }}</router-link></span>
                </h5>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <formulario-anexar class="p-2"
            :numeroProcesso="numeroProcesso"
            :rowsNumber="5"
            :eventBusDataName="eventBusDataName"
            :eventBusPaginationName="eventBusPaginationName"
            :eventBusRecarregar="eventBusRecarregar"/>
        </div>
      </div>
    </div>

    <div class="container-xl">
      <data-table-consulta-comp class="p-2"
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :dataTableColumn="dataTableColumn"
        :colWidth="colWidth">
        <template v-slot="slotProps">
          <td v-if="excluirIsVisible()" style="text-align: center; width: 100px !important; white-space: nowrap;">
              <i class="fa fa-times fa-1-5x" aria-hidden="true" v-on:click="excluir(slotProps.itemData, $refs)"></i>
          </td>
        </template>
      </data-table-consulta-comp>
    </div>
    <modal ref="modalName" width="750px" height="" :eventBusModal="eventBusModal">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Desanexar</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.modalName.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <desanexar
            :eventBusRecarregar="eventBusRecarregar"
            :processoDesanexado="processoDesanexado"/>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import menuProcesso from '@/components/MenuProcesso.vue'
import formularioAnexar from '@/components/anexar/FormularioAnexar'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import Desanexar from '@/components/anexar/Desanexar'
import eventBus from '@/uteis/eventBus'
import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'
import modal from '@/components/shared/Modal.vue'

import VirtusService from '@/services/VirtusService'
import { componentIsVisible, rules } from '@/uteis/action/permissao'

export default {
  name: 'anexar',
  components: {
    menuPae,
    menuProcesso,
    formularioAnexar,
    dataTableConsultaComp,
    Desanexar,
    modal
  },

  data () {
    return {
      colNames: ['Processo Anexado', 'Solicitante', 'Data do Anexeção', 'Ações'],
      colWidth: [20, 40, 20, 20],
      dataTableColumn: [
        {
          column: 'processoAnexado',
          converter: 'protocolo'
        }, 'solicitante.titulo',
        {
          column: 'data',
          converter: 'localDate'
        }],
      eventBusDataName: 'consultaProcessoAnexado',
      eventBusPaginationName: 'consultaProcessoAnexadoDataPagination',
      eventBusRecarregar: 'regarregarTabelaAnexado',
      eventBusModal: 'closeModal',
      processoDesapensado: {},
      processoDesanexado: {},
      filtro: {
        offset: 1,
        range: 10
      }
    }
  },

  created () {
    this.service = new VirtusService()
    this.numeroProcesso = this.$route.query.numeroProcesso
    this.apensado = this.$route.query.apensado

    this.pesquisar()

    eventBus.$on(this.eventBusRecarregar, () => {
      this.pesquisar()
      this.$refs.modalName.closeModal()
    })

    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.pesquisar(numeroPagina)
    })
  },

  methods: {
    excluir (obj, refs) {
      obj.processoDesanexado = obj.processoAnexado
      obj.motivo = 'Nenhum'

      this.processoDesanexado = obj
      refs.modalName.openModal()
    },
    pesquisar (page = 1) {
      this.filtro.offset = page
      this.service.consultaAnexacoes(this.numeroProcesso, this.filtro).then((response) => {
        eventBus.$emit(this.eventBusDataName, response)
      })
    },
    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo)
    },
    excluirIsVisible () {
      const { DESANEXAR_PROTOCOLO } = rules
      return componentIsVisible(DESANEXAR_PROTOCOLO)
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.footer {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }

  div {
    width: 100%;
  }
}
</style>
